<template>
  <div class="import-travellers">
    <traveller-import @travellerImported="onTravellerImported"/>
    <a id="tooltip-button-show-event" @click="$bvModal.show('import-travellers')">
      <span>{{ $t('traveller.import.title') }}</span>

      <span class="btn orange-white">
         <i class="fas fa-file-upload"></i>
      </span>
    </a>
    <b-tooltip ref="tooltip" target="tooltip-button-show-event">
      {{ $t('traveller.import.title') }}
    </b-tooltip>
  </div>
</template>

<script>
import travellerImport from '@/components/global/modal/travellerImport'

export default {
  methods: {
    onTravellerImported (data) {
      this.$emit('travellerImported', data)
    }
  },

  components: {
    travellerImport
  }
}
</script>
<style scoped lang="scss">
#tooltip-button-show-event{
  span:first-child {
    font-size: 1rem;
    margin-right: .5rem;
  }
}
</style>